import { z } from 'zod';
/**
 * Live transcription events pushed over SSE by LiveTranscriptionService.
 *
 * Subscription URL: GET /api/twilio/live-transcript/:callId
 * Each event is a single SSE data: line (JSON object). The service uses
 * one JSON per line rather than named events for historical reasons.
 *
 * The frontend useLiveTranscript hook (REFACTORING_FRONTEND_PLAN.md §12)
 * demultiplexes on the `event` field.
 *
 * Matches the broadcast() shape in
 *   server/src/application/calling/LiveTranscriptionService.ts
 */
export const LiveTranscriptSpeakerSchema = z.enum(['inbound', 'outbound']);
export const LiveTranscriptSentimentSchema = z.enum([
    'neutral',
    'positive',
    'objection',
    'closing',
]);
export const LiveTranscriptPacingLevelSchema = z.enum([
    'very-low',
    'low',
    'medium',
    'medium-high',
    'high',
]);
/** Discriminated union on the `event` field — this is what the SSE JSON carries. */
export const LiveTranscriptEventSchema = z.discriminatedUnion('event', [
    z.object({
        event: z.literal('segment'),
        speaker: LiveTranscriptSpeakerSchema,
        text: z.string(),
        timestamp: z.number(),
    }),
    z.object({
        event: z.literal('ratio'),
        agent: z.number(),
        prospect: z.number(),
        warning: z.string().nullable(),
    }),
    z.object({
        event: z.literal('signal'),
        type: z.enum(['buying', 'danger']),
        text: z.string(),
        timestamp: z.number(),
    }),
    z.object({
        event: z.literal('battlecard'),
        category: z.string(),
        objection: z.string(),
        response: z.string(),
        successRate: z.number(),
    }),
    z.object({
        event: z.literal('pacing'),
        wpm: z.number(),
        level: LiveTranscriptPacingLevelSchema,
        warning: z.string().nullable(),
    }),
    z.object({
        event: z.literal('sentiment'),
        value: LiveTranscriptSentimentSchema,
        suggestion: z.string().nullable(),
    }),
    z.object({
        event: z.literal('end'),
        callId: z.string(),
    }),
    z.object({
        event: z.literal('no-session'),
        callId: z.string(),
    }),
]);
//# sourceMappingURL=live-transcript.schema.js.map